<span
  class="info-toggle"
  [class.showInfo]="infoToggleState"
  [class.hideInfo]="!infoToggleState"
  (click)="onInfoToggleClicked()"
>
  <i class="icomoon-nbr-info" aria-hidden="true"></i>
</span>
